
export const api = "https://oqqrzz5kyb.execute-api.eu-west-1.amazonaws.com/dev";
